import React from 'react';
import type { AuthSectionProps } from '~/lib/types/netlify';

export const AuthSection = ({ isCheckingToken, tokenCheckCount, onConnect, onAbort }: AuthSectionProps) => {
  return (
    <div className="flex flex-col gap-3">
      <button
        onClick={onConnect}
        disabled={isCheckingToken}
        className="w-full px-6 py-2.5 bg-white 
        rounded-md text-black text-sm font-semibold shadow-sm
        hover:bg-[#e6e6e6] transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed 
        flex items-center justify-center gap-2"
      >
        {isCheckingToken ? (
          <>
            <div className="i-ph:circle-notch w-4 h-4 animate-spin mr-2" />
            Connecting... ({30 - tokenCheckCount}s)
          </>
        ) : (
          'Connect with Netlify'
        )}
      </button>

      {isCheckingToken && (
        <button
          onClick={onAbort}
          className="w-full px-6 py-2.5 bg-transparent border border-white/20 
          rounded-md text-white text-sm font-medium 
          hover:bg-white/5 transition-colors"
        >
          Cancel
        </button>
      )}
    </div>
  );
};
